/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomButton from "components/CustomButton/CustomButton";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
//#endregion
//#region Images and Icons
import searchIcon from "img/search_icon.svg";
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Utils
import { getToday } from "components/CustomDatePicker/utils/helpers";
import { getDatePeriodFilters } from "../../../../utils/constants";
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { LOCATION_IDS } from "config/constants";
import TutorFilter from "./components/TutorFilter/TutorFilter";
//#endregion

const Filters = ({
    isTutorUser,
    data: {
        acadReinforceTypeList,
        locations, campusList
    }, filters, paginator, currentTabIdx,
    resetUI, triggerFillAcadReinforceList,
    loadingRequest, disabled
}) => {
    const {
        title, date,
        acadReinforceTypeId,
        tutorId, locationId,
        campusId
    } = filters.value;
    //#region States
    const [timeoutIdForTriggerFillAcadReinforceListWhenTitleChanged, setTimeoutIdForTriggerFillAcadReinforceListWhenTitleChanged] = useState(null);
    const [customDatePeriod, setCustomDatePeriod] = useState({
        min: getToday(),
        max: [3000, 1, 1]
    });
    //#endregion
    //#region Effects
    useEffect(() => {
        const DATE_PERIOD_FILTERS = getDatePeriodFilters(isTutorUser);
        const newPeriod = DATE_PERIOD_FILTERS[currentTabIdx];
        setCustomDatePeriod(newPeriod);
    }, [currentTabIdx]);
    //#endregion
    //#region Functions
    const changeTitleField = value => {
        filters.change("title", value);
        clearTimeout(timeoutIdForTriggerFillAcadReinforceListWhenTitleChanged);
        const timeoutId = setTimeout(() => {
            paginator.clear();
            triggerFillAcadReinforceList();
        }, 750);
        setTimeoutIdForTriggerFillAcadReinforceListWhenTitleChanged(timeoutId);
    }
    const changeDateField = value => {
        filters.change("date", value);
        paginator.clear();
        triggerFillAcadReinforceList();
    }
    const changeAcadReinforceTypeField = value => {
        filters.change("acadReinforceTypeId", value);
        paginator.clear();
        triggerFillAcadReinforceList();
    }
    const changeLocationField = value => {
        filters.change("locationId", value);
        if (value !== LOCATION_IDS.ZOOM) return;
        filters.change("campusId", 0);
        paginator.clear();
        triggerFillAcadReinforceList();
    }
    const changeCampusField = value => {
        filters.change("campusId", value);
        paginator.clear();
        triggerFillAcadReinforceList();
    }
    const changeTutorField = value => {
        filters.change("tutorId", value);
        paginator.clear();
        triggerFillAcadReinforceList();
    }
    //#endregion
    return (
        <Row justifyContent="flex-start" align="flex-end">
            <CustomTextInput 
                label="Nombre del refuerzo"
                placeholder="Buscar por nombre"
                minWidth="330px"
                iconAdornment={<img src={searchIcon} alt="Imagen de búsqueda UTP"/>}
                value={title}
                onChange={changeTitleField}
                disabled={disabled}/>
            <CustomDatePicker
                label="Fecha"
                placeholder="Buscar un refuerzo por fecha"
                value={date}
                period={customDatePeriod}
                onChange={changeDateField}
                disabled={disabled}/>
            {!isTutorUser && 
            <CustomSelect 
                label="Categoría"
                value={acadReinforceTypeId}
                optionsProps={getOptionsToCustomSelect(acadReinforceTypeList, { id: "id", text: "name" })}
                onChange={changeAcadReinforceTypeField}
                defaultOptionText="Elige una categoría"
                minWidth="180px"
                disabled={disabled}/>}
            {!isTutorUser && 
            <TutorFilter
                loadingRequest={loadingRequest}
                value={tutorId}
                onChange={changeTutorField}
                disabled={disabled}/>}
            <CustomSelect 
                label="Ubicación"
                value={locationId}
                optionsProps={getOptionsToCustomSelect(locations, { id: "id", text: "name" })}
                onChange={changeLocationField}
                defaultOptionText="Elige una ubicación"
                minWidth="180px"
                disabled={disabled}/>
            {locationId === LOCATION_IDS.PLACE &&
            <CustomSelect 
                label="Campus"
                value={campusId}
                optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                onChange={changeCampusField}
                defaultOptionText="Elige un campus"
                minWidth="200px"
                disabled={disabled}/>}
            <CustomButton 
                variant="secondary"
                size="small"
                disabled={disabled || filters.isCleared()}
                icon={<TrashIcon/>}
                text="Limpiar"
                onClick={resetUI}/>
        </Row>
    );
}

export default Filters;